// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { teasers as T } from '../../../opopular/assets/teasers';
import { PageBlockTypes as p } from '@xprog/prensa/types'

export const LayoutVideoLive: p.SlotConfigProps = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        default: [T.TeaserVideoTop, T.TeaserVideoTop]
      },
      slotCenter: {
        default: [T.TeaserVideoTop, T.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        default: [T.TeaserMostRead, T.TeaserMostRead]
      }
    },
  }
}